import { Btn } from 'components/Btn'
import { CTA } from 'components/CTA'
import { Heading } from 'components/Heading'
import { MerifyIrma405Svg } from 'images'
import { Text } from 'components/Text'
import { P } from 'components/Typography/P'
import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { get } from 'utils'

export const errorBlockStyles = css`
	padding: 1rem ${props => props.theme.sizes.gutter.mobile.val};

	${props => props.theme.media.tablet} {
		padding: 1rem ${props => props.theme.sizes.gutter.tablet.val};
		max-width: 600px;
		margin: 0 auto;
	}

	&.display-full {
	}

	&.display-inline {
	}

	h2,
	p {
		color: ${props => props.theme.colors.err.val};
	}

	.full {
		text-align: center;
		height: 80vh;

		h2 {
			font-size: 4rem;
			margin-bottom: 2rem;
		}
		svg {
			display: block;
			width: 100%;
			height: auto;
		}
	}

	.inline {
		//height: 80px;
		display: flex;
		padding: 1rem;
		border: solid 1px ${props => props.theme.colors.err.val};
		align-items: center;

		svg {
			display: block;
			height: 100%;
			max-height: 60px;
			width: auto;
			flex: 1;
		}
		.text {
			margin-left: 1rem;
			flex: 3;
			h2 {
				line-height: 1.7rem;
			}
			p {
				margin: 5px 0 0 0;
			}
		}

		button {
			margin-left: auto;
			flex: 1;
		}
	}

	.simple {
		display: flex;
		align-items: center;
		padding: 1rem;
		border: solid 1px ${props => props.theme.colors.err.val};
		color: ${props => props.theme.colors.err.val};

		button {
			margin-left: auto;
		}
	}
`

const ErrorBlockView = styled.div`
	${errorBlockStyles}
`

export type ErrorBlockErr = Error | Error[] | unknown

type ErrorBlockProps = {
	error: ErrorBlockErr | null
	display?: 'inline' | 'full' | 'simple'
	hideCta?: boolean
	showErr?: boolean
	children?: ReactNode
}
export const ErrorBlock = ({
	error,
	display = 'full',
	showErr,
	hideCta,
	children,
}: ErrorBlockProps) => {
	// const err = Array.isArray(error) ? error : [error]

	const msg = get(error, 'message', '')
	const text =
		typeof children === 'string'
			? children
			: showErr && msg
			? msg
			: 'Something seems to have gone wrong...'
	return error ? (
		<ErrorBlockView className={`error-block display-${display}`}>
			{display === 'full' ? (
				<div className='full'>
					<Heading displayType='screen-heading'>Uh oh...</Heading>
					<MerifyIrma405Svg />
					{children && typeof children !== 'string' ? children : <P isBig>{text}</P>}
					{hideCta ? null : (
						<CTA size='sm'>
							<Btn onClick={() => (window.location.href = '/skills')}>Refresh</Btn>
						</CTA>
					)}
				</div>
			) : display === 'inline' ? (
				<div className='inline'>
					<MerifyIrma405Svg />
					<div className='text'>
						<Heading displayType='screen-heading'>Uh oh...</Heading>
						{children && typeof children !== 'string' ? (
							children
						) : (
							<Text size='normal'>{text}</Text>
						)}
					</div>
					{hideCta ? null : (
						<CTA size='sm'>
							<Btn onClick={() => window.location.replace(window.location.href)}>Refresh</Btn>
						</CTA>
					)}
				</div>
			) : display === 'simple' ? (
				<div className='simple'>
					<div className='text'>
						{children && typeof children !== 'string' ? (
							children
						) : (
							<Text size='normal'>{text}</Text>
						)}
					</div>
					{hideCta !== false ? null : (
						<CTA size='sm'>
							<Btn onClick={() => window.location.replace(window.location.href)}>Refresh</Btn>
						</CTA>
					)}
				</div>
			) : null}
			{/* {children || err?.length
				? err.map((e, idx) => (
						<span className='err-msg' key={idx}>
							ERROR: {e?.message}
						</span>
				  ))
				: null} */}
		</ErrorBlockView>
	) : (
		<>{children}</>
	)
}
